export default __webpack_public_path__ + "static/media/star2.a68b2b14.gif";